import type { AbstractControl, ValidationErrors } from '@angular/forms';

import type { Observable } from 'rxjs';
import { delay, map, of, switchMap } from 'rxjs';

import type { TellentMembersHttpClient } from '../store/tellent-members.http';

export function existingTellentMemberValidator(tellentMembersHttpClient: TellentMembersHttpClient) {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    const value = control.value.toLowerCase();

    return of(control.value).pipe(
      delay(250),
      switchMap(() => tellentMembersHttpClient.fetchMemberByEmail(value)),
      map(members => {
        const existingMember = members.find(member => member.email === value);
        return !!existingMember ? { ...control.errors, existingMember } : control.errors;
      }),
    );
  };
}

export function existingAppMemberValidator(tellentMembersHttpClient: TellentMembersHttpClient) {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    const value = control.value.toLowerCase();

    return of(control.value).pipe(
      delay(250),
      switchMap(() => tellentMembersHttpClient.fetchAppMemberByEmail(value)),
      map(members => {
        const existingMember = members.find(member => member.email === value);
        return !!existingMember ? { ...control.errors, existingMember } : control.errors;
      }),
    );
  };
}
